// @todo check unused font files
export default {
  brand   : 'BlinkerBold',
  default : 'MontserratMedium',
};
